<template>
  <section id="privacyPolicy" class="terms section-show" style="height: auto!important;">
    <div class="container">

      <h2>Согласие на обработку персональных данных</h2>
      <p>
        Настоящим, я, Пользователь, в соответствии с Федеральным законом от 27.07.2006 №152-ФЗ «О персональных данных»,
        свободно, своей волей и в своем интересе предоставляю свое полное согласие на обработку моих персональных данных
        иной категории (не относящиеся к специальной категории персональных данных или биометрическим персональным
        данным) (далее - «Согласие») Индивидуальному предпринимателю Самигуллину Евгению Марселевичу, ИНН/КПП
        745208585592, ОГРНИП 317745600168025, адрес: 454071, Челябинская Область, Челябинск Город, Правдухина Улица, дом
        д. 14, кв./офис кв. 4 (далее – «Оператор»), указываемых при заполнении форм сбора на сайте Оператора по адресу:
        https://zavbus.ru/ (далее – «Сайт»).
      </p>

      <p>
        1. Цели обработки и категории персональных данных:
      </p>
      <div class="table-responsive consent-table-wrap">
        <table class="table table-dark table-striped table-hover align-middle consent-table">
          <thead>
          <tr>
            <td>Цель</td>
            <td>Перечень обрабатываемых персональных данных</td>
            <td>Категория субъектов</td>
            <td>Способы обработки</td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>Подготовка, заключение и исполнение гражданско-правового договора</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество</li>
                <li>год рождения</li>
                <li>месяц рождения</li>
                <li>дата рождения</li>
                <li>место рождения</li>
                <li>номер телефона</li>
                <li>адрес электронной почты</li>
                <li>адрес места жительства</li>
                <li>адрес регистрации</li>
                <li>ИНН</li>
                <li>данные документа, удостоверяющего личность</li>
                <li>данные водительского удостоверения</li>
                <li>реквизиты банковской карты</li>
                <li>номер расчетного счета</li>
                <li>фото-видео изображение лица</li>
                <li>рост</li>
                <li>вес</li>
                <li>размер ноги</li>
                <li>аккаунт социальной сети VK</li>
              </ul>
            </th>
            <th>Контрагенты, представители контрагентов, клиенты, посетители сайта, выгодоприобретатели по договорам,
              законные представители
            </th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
          </tr>
          <tr>
            <th>Продвижение товаров, работ, услуг на рынке</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество</li>
                <li>номер телефона</li>
                <li>адрес электронной почты</li>
              </ul>
            </th>
            <th>Клиенты, посетители сайта, законные представители</th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
          </tr>
          <tr>
            <th>Обеспечение работы и предоставление доступа к сайту и его возможностям пользователям</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество</li>
                <li>номер телефона</li>
                <li>адрес электронной почты</li>
                <li>номер телефона</li>
                <li>сведения собираемые посредством метрических систем</li>
                <li>фото-видео изображение лица</li>
                <li>аккаунт социальной сети VK</li>
              </ul>
            </th>
            <th>Клиенты, посетители сайта, законные представители</th>
            <th>Сбор, систематизация, накопление, хранение, передача (предоставление, доступ), блокирование,
              уничтожение,
              запись, уточнение (обновление, изменение), использование, удаление
            </th>
          </tr>
          <tr>
            <th>Обработка обращений пользователей сайта и иных частных лиц</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество</li>
                <li>номер телефона</li>
                <li>адрес электронной почты</li>
              </ul>
            </th>
            <th>Клиенты, посетители сайта, выгодоприобретатели по договорам, законные представители</th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
          </tr>
          <tr>
            <th>Размещение отзывов и комментариев, полученных в ходе оказания услуг</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество</li>
                <li>номер телефона</li>
              </ul>
            </th>
            <th>Клиенты, посетители сайта</th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление, распространение
            </th>
          </tr>
          <tr>
            <th>Улучшение качества обслуживания пользователей и модернизация сайта</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество</li>
                <li>адрес электронной почты</li>
                <li>номер телефона</li>
                <li>сведения, собираемые посредством метрических программ</li>
                <li>cookie-файлы</li>
              </ul>
            </th>
            <th>Клиенты, посетители сайта, выгодоприобретатели по договорам, законные представители</th>
            <th>
              Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
          </tr>
          <tr>
            <th>Исполнение требований и запросов государственных органов РФ</th>
            <th>
              <ul>
                <li>фамилия, имя, отчество- номер телефона</li>
                <li>адрес электронной почты</li>
              </ul>
            </th>

            <th>Контрагенты, представители контрагентов, клиенты, посетители сайта, выгодоприобретатели по договорам,
              законные представители
            </th>
            <th>Сбор, систематизация, хранение, , передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление)
            </th>
          </tr>
          </tbody>
        </table>
      </div>

      <p></p>

      <p>
        2. Согласие выдано на обработку персональных данных с использованием средств автоматизации, а также смешанным
        способом; с передачей по внутренней сети юридического лица; с передачей по сети Интернет.
      </p>

      <p>
        3. Датой выдачи настоящего Согласия является дата заполнения и отправки соответствующей формы на Сайте
        Оператора. Согласие действует с момента его предоставления в течение всего периода использования Пользователем
        Сайта, до момента отзыва согласия либо до достижения вышеуказанных целей обработки персональных данных, с учетом
        п. 4, 7 настоящего Согласия.
      </p>

      <p>
        4. Условием для прекращения обработки является: исключения оператора из ЕГРИП; отзыв субъектом своего согласия
        на обработку персональных данных, если иное не предусмотрено законодательством РФ; истечение срока обработки
        персональных данных; истечение срока действия согласия субъекта на обработку его персональных данных; достижение
        целей обработки персональных данных.
      </p>

      <p>
        5. Пользователь имеет право отозвать свое Согласие следующими способами:
        - направив по адресу Оператора отзыв согласия на обработку персональных данных в бумажном виде с содержанием
        собственноручной подписи субъекта персональных данных или его законного представителя;
        - направив отзыв согласия на обработку персональных данных в электронной форме на электронную почту:
        zavbus@mail.ru, с пометкой «Отзыв согласия на обработку персональных данных».
      </p>

      <p>
        6. Оператор обязуется в течение 30 (тридцати) дней, с момента получения уведомления об отзыве Согласия,
        прекратить обработку персональных данных, и в случае, если сохранение персональных данных более не требуется для
        целей обработки персональных данных, уничтожить их в установленном законом порядке.
      </p>

      <p>
        7. В случае отзыва Пользователем Согласия на обработку персональных данных Оператор вправе продолжить обработку
        персональных данных без согласия Пользователя при наличии оснований, предусмотренных законодательством
        Российской федерации.
      </p>

      <p>
        8. Оператор гарантирует соблюдение следующих прав субъекта персональных данных: право на получение сведений о
        том, какие персональные данные субъекта персональных данных хранятся у Оператора; право на удаление, уточнение
        или исправление хранящихся у Оператора персональных данных; иные права, установленные действующим
        законодательством Российской Федерации.
      </p>

      <p>
        9. Обращаем внимание Пользователя, что отзыв согласия на обработку персональных данных влечёт за собой удаление
        учётной записи с Сайта, а также уничтожение записей, содержащих персональные данные, в информационных системах
        обработки персональных данных Оператора, что может сделать невозможным для пользования Сайтом Оператора.
      </p>

      <p>
        10. Заверения и гарантии Пользователя сайта:
        - Пользователь проинформирован и настоящим соглашается с тем, что Оператор не проверяет достоверность
        предоставленных персональных данных. Пользователь сайта гарантирует, что указанные им на Сайте персональные
        данные принадлежат ему, и обязуется проинформировать Оператора, в случае прекращения использования им
        персональных данных, указанных на Сайте. Указывая персональные данные, принадлежащие третьим лицам, Пользователь
        сайта гарантирует, что получил согласие от такого третьего лица на обработку его персональных данных и
        гарантирует предоставление такого согласия по запросу Оператора.
        - Пользователь сайта ознакомлен с Политикой в отношении обработки персональных данных на сайте
        https://zavbus.ru/.
      </p>

      <p>
        11. Реквизиты Оператора:
        ИП Самигуллин Евгений Марселевич
        454071, Челябинская Область, Челябинск Город, Правдухина Улица, дом д. 14, кв./офис кв. 4,
        ИНН 745208585592, ОГРНИП 317745600168025
        Тел: +7 (351) 750-72-87, E-mail: zavbus@mail.ru
      </p>


      <hr>

      <p>
        Приложение № 1 к Политике в отношении
        обработки персональных данных ИП Самигуллина Е.М.
        в редакции от 01.02.2025 года
      </p>

      <h2>
        Цели обработки, категории и перечень обрабатываемых персональных данных
      </h2>

      <div class="table-responsive consent-table-wrap">
        <table class="table table-dark table-striped table-hover align-middle consent-table">
          <thead>
          <tr>
            <td>№</td>
            <td>Категория субъектов</td>
            <td>Цель</td>
            <td>Перечень обрабатываемых персональных данных</td>
            <td>Способы обработки</td>
            <td>Сроки обработки</td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>1</th>
            <th>Контрагенты, представители контрагентов, клиенты, посетители сайта, выгодоприобретатели по договорам,
              законные представители
            </th>
            <th>Подготовка, заключение и исполнение гражданско-правового договора</th>
            <th>Фамилия, имя, отчество, год рождения, месяц рождения, дата рождения, место рождения, адрес электронной
              почты, адрес места жительства, адрес регистрации номер телефона, ИНН, гражданство, данные документа,
              удостоверяющего личность, данные водительского удостоверения, реквизиты банковской карты, номер расчетного
              счета, фото-видео изображение лица рост, вес, размер ноги, аккаунт в социальной сети
            </th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
            <th>До момента окончания исполнения гражданско-правового договора</th>
          </tr>
          <tr>
            <th>2</th>
            <th>Клиенты, посетители сайта, законные представители</th>
            <th>Продвижение товаров, работ, услуг на рынке</th>
            <th>Фамилия, имя, отчество, адрес электронной почты, номер телефона</th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
            <th>До получения от субъекта персональных данных требования о прекращении обработки/отзыва согласия</th>
          </tr>
          <tr>
            <th>3</th>
            <th>Клиенты, посетители сайта, законные представители</th>
            <th>Обеспечение работы и предоставление доступа к сайту и его возможностям пользователям</th>
            <th>Фамилия, имя, отчество, адрес электронной почты, номер телефона, сведения, собираемые посредством
              метрических программ, фото-видео изображение лица, аккаунт в социальной сети VK
            </th>
            <th>Сбор, систематизация, накопление, хранение, передача (предоставление, доступ), блокирование,
              уничтожение, запись, уточнение (обновление, изменение), использование, удаление
            </th>
            <th>До момента прекращения использования Пользователем Сайта</th>
          </tr>
          <tr>
            <th>4</th>
            <th>Клиенты, посетители сайта, выгодоприобретатели по договорам, законные представители</th>
            <th>Обработка обращений пользователей сайта и иных частных лиц</th>
            <th>Фамилия, имя, отчество, адрес электронной почты, номер телефона</th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
            <th>До получения от субъекта персональных данных требования о прекращении обработки/отзыва</th>
          </tr>
          <tr>
            <th>5</th>
            <th>Клиенты, посетители сайта</th>
            <th>Размещение отзывов и комментариев, полученных в ходе оказания услуг</th>
            <th>Фамилия, имя, отчество, номер телефона</th>
            <th>Сбор, систематизация, хранение, , передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление, распространение
            </th>
            <th>До получения от субъекта персональных данных требования о прекращении обработки/отзыва</th>
          </tr>
          <tr>
            <th>6</th>
            <th>Клиенты, посетители сайта, выгодоприобретатели по договорам, законные представители</th>
            <th>Улучшение качества обслуживания пользователей и модернизация сайта</th>
            <th>Фамилия, имя, отчество, адрес электронной почты, номер телефона, сведения, собираемые посредством
              метрических программ
            </th>
            <th>Сбор, систематизация, хранение, передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление
            </th>
            <th>До получения от субъекта персональных данных требования о прекращении обработки/отзыва</th>
          </tr>
          <tr>
            <th>7</th>
            <th>Контрагенты, представители контрагентов, клиенты, посетители сайта, выгодоприобретатели по договорам,
              законные представители
            </th>
            <th>Исполнение требований и запросов государственных органов РФ</th>
            <th>Фамилия, имя, отчество, адрес электронной почты, номер телефона,</th>
            <th>Сбор, систематизация, хранение, , передача (предоставление, доступ), блокирование, уничтожение, запись,
              накопление, уточнение (обновление, изменение), использование, удаление)
            </th>
            <th>До получения от субъекта персональных данных требования о прекращении обработки/отзыва</th>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'PrivacyPolicyPage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
</script>

<style scoped>
/* Обёртка */
.consent-table-wrap {
  overflow: hidden;
  background: rgba(0, 0, 0, .45);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, .12);
  box-shadow: 0 16px 40px rgba(0, 0, 0, .35);
}

/* Таблица */
.consent-table {
  margin-bottom: 0;
  font-size: 14px;
}

/* Шапка */
.consent-table thead th {
  position: sticky; /* шапка “липнет” при скролле */
  top: 0;
  z-index: 2;
  background: rgba(10, 10, 10, .92);
  border-bottom: 1px solid rgba(255, 255, 255, .12);
  letter-spacing: .2px;
}

/* Ячейки */
.consent-table td, .consent-table th {
  padding: 16px 14px;
  vertical-align: top;
  border-color: rgba(255, 255, 255, .08);
}

/* Списки внутри ячеек */
.consent-table ul {
  padding-left: 18px;
}

.consent-table li {
  margin: 4px 0;
}

/* Hover помягче */
.consent-table.table-hover tbody tr:hover {
  background: rgba(255, 255, 255, .06);
}
</style>
